import {createSlice} from "@reduxjs/toolkit";


const initialState = {
    checked: true,
};


const checkedSlice = createSlice({
    name: "checked",  
    initialState,
    reducers: {
        setChecked: (state, action) => {  
            state.checked = action.payload;

        },
    },
});

export const {setChecked} = checkedSlice.actions; //action creator'ı dışa aktardım.
export default checkedSlice.reducer;
